import { Link } from "react-router-dom";
import React from "react";

const WhyChooseUs = () => {
  return (
    <>
      <section className="ah-bg ah-service pt-120 pb-60 overflow-hidden">
        <div className="container position-relative z-1">
          <div className="row justify-content-center">
            <div className="col-xxl-11 col-xl-7 col-lg-10">
              <div className="text-center mb-40">
                <h2 className="ail-title text-black fs-48 fw-600">
                  Why{" "}
                  <span className="ail-highlighted-text">
                    choose us?
                  </span>
                </h2>
                <h2 className="pay-gw-title text-black fs-18 ff-risk-pri">
                  We're payments experts here to help improve customer experience, revenue growth, and operational efficiencies.
                  By choosing us as your payments partner, you'll have a dedicated account manager and a technology and risk support team
                  behind you at every step.
                </h2>
              </div>
            </div>
          </div>
          <div className="row g-4 justify-content-center">
            <div className="col-xxl-3 col-lg-4 col-md-6">
              <div className="dg-service-item bg-white rounded">
                <div className="icon-wrapper rounded-circle shadow-1">
                  <span className="d-inline-flex align-items-center justify-content-center rounded-circle w-100 h-100 bg-color-1">
                    <svg
                      width="24"
                      height="26"
                      viewBox="0 0 24 26"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M22.6 7V19C22.6 22.6 20.8 25 16.6 25H7C2.8 25 1 22.6 1 19V7C1 3.4 2.8 1 7 1H16.6C20.8 1 22.6 3.4 22.6 7Z"
                        stroke="white"
                        strokeWidth="1.5"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M13.3 15.4H18.4M8.20004 20.2H18.4M16 1V10.432C16 10.96 15.376 11.224 14.992 10.876L12.208 8.308C12.0976 8.20405 11.9517 8.14616 11.8 8.14616C11.6484 8.14616 11.5025 8.20405 11.392 8.308L8.60804 10.876C8.22404 11.224 7.60004 10.96 7.60004 10.432V1H16Z"
                        stroke="white"
                        strokeWidth="1.5"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                </div>
                <Link href="agency-home-new">
                  <h5 className="mt-4 mb-2 heading-dg-color">
                    50+
                  </h5>
                </Link>
                <p className="mb-3 text-dg-color">
                  Payment Methods. Support for all major payment types.
                </p>
                <span className="number-count position-relative color-1 fw-semibold">
                  01
                </span>
              </div>
            </div>
            <div className="col-xxl-3 col-lg-4 col-md-6">
              <div className="dg-service-item bg-white rounded">
                <div className="icon-wrapper rounded-circle shadow-2">
                  <span className="d-inline-flex align-items-center justify-content-center rounded-circle w-100 h-100 bg-color-2">
                    <svg
                      width="26"
                      height="26"
                      viewBox="0 0 26 26"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10.12 22.6H15.88C20.68 22.6 22.6 20.68 22.6 15.88V10.12C22.6 5.32002 20.68 3.40002 15.88 3.40002H10.12C5.31999 3.40002 3.39999 5.32002 3.39999 10.12V15.88C3.39999 20.68 5.31999 22.6 10.12 22.6Z"
                        stroke="white"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M8.212 3.4V1M13 3.4V1M17.8 3.4V1M22.6 8.2H25M22.6 13H25M22.6 17.8H25M17.8 22.6V25M13.012 22.6V25M8.212 22.6V25M1 8.2H3.4M1 13H3.4M1 17.8H3.4M11.2 19H14.8C17.8 19 19 17.8 19 14.8V11.2C19 8.2 17.8 7 14.8 7H11.2C8.2 7 7 8.2 7 11.2V14.8C7 17.8 8.2 19 11.2 19Z"
                        stroke="white"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M13 10.24L11.872 12.208C11.62 12.64 11.824 13 12.328 13H13.672C14.176 13 14.38 13.36 14.128 13.792L13 15.76"
                        stroke="white"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                </div>
                <Link href="agency-home-new">
                  <h5 className="mt-4 mb-2 heading-dg-color">
                    40+
                  </h5>
                </Link>
                <p className="mb-3 text-dg-color">
                  Processing Currencies. Global currency coverage.
                </p>
                <span className="number-count position-relative color-2 fw-semibold">
                  02
                </span>
              </div>
            </div>
            <div className="col-xxl-3 col-lg-4 col-md-6">
              <div className="dg-service-item bg-white rounded">
                <div className="icon-wrapper rounded-circle shadow-3">
                  <span className="d-inline-flex align-items-center justify-content-center rounded-circle w-100 h-100 bg-color-3">
                    <svg
                      width="24"
                      height="26"
                      viewBox="0 0 24 26"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M20.2 13V5.8C20.2 3.148 20.2 1 15.4 1H8.2C3.4 1 3.4 3.148 3.4 5.8V13M5.8 13C1 13 1 15.148 1 17.8V19C1 22.312 1 25 7 25H16.6C21.4 25 22.6 22.312 22.6 19V17.8C22.6 15.148 22.6 13 17.8 13C16.6 13 16.264 13.252 15.64 13.72L14.416 15.016C14.0795 15.3739 13.6732 15.6592 13.2223 15.8542C12.7714 16.0492 12.2853 16.1497 11.794 16.1497C11.3027 16.1497 10.8166 16.0492 10.3657 15.8542C9.91475 15.6592 9.50852 15.3739 9.172 15.016L7.96 13.72C7.336 13.252 7 13 5.8 13Z"
                        stroke="white"
                        strokeWidth="1.5"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M10.06 9.67593H14.056M9.06396 6.07593H15.064"
                        stroke="white"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                </div>
                <Link href="agency-home-new">
                  <h5 className="mt-4 mb-2 heading-dg-color">24/7</h5>
                </Link>
                <p className="mb-3 text-dg-color">
                  Tech Support. Round-the-clock assistance.
                </p>
                <span className="number-count position-relative color-3 fw-semibold">
                  03
                </span>
              </div>
            </div>
            <div className="col-xxl-3 col-lg-4 col-md-6">
              <div className="dg-service-item bg-white rounded">
                <div className="icon-wrapper rounded-circle shadow-4">
                  <span className="d-inline-flex align-items-center justify-content-center rounded-circle w-100 h-100 bg-color-4">
                    <svg
                      width="26"
                      height="26"
                      viewBox="0 0 26 26"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5.7904 4.58979V6.991M10.5928 4.58979V6.991M5.7904 18.997V21.3982M10.5928 18.997V21.3982M15.3952 5.7904H20.1976M15.3952 20.1976H20.1976M21.7824 10.5928H4.21761C2.44072 10.5928 1 9.14007 1 7.37519V4.21761C1 2.44072 2.45273 1 4.21761 1H21.7824C23.5593 1 25 2.45273 25 4.21761V7.37519C25 9.14007 23.5473 10.5928 21.7824 10.5928ZM21.7824 25H4.21761C2.44072 25 1 23.5473 1 21.7824V18.6248C1 16.8479 2.45273 15.4072 4.21761 15.4072H21.7824C23.5593 15.4072 25 16.8599 25 18.6248V21.7824C25 23.5473 23.5473 25 21.7824 25Z"
                        stroke="white"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                </div>
                <Link href="agency-home-new">
                  <h5 className="mt-4 mb-2 heading-dg-color">25+</h5>
                </Link>
                <p className="mb-3 text-dg-color">
                  Settlement Currencies. Global presence & support.
                </p>
                <span className="number-count position-relative color-4 fw-semibold">
                  04
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default WhyChooseUs;
